<template>
  <div>
    <div class="vx-row">
      <!-- MULTIPLE COLUMNS-->
      <div class="vx-col lg:w-4/4 w-full relative">
        <vx-card title="" v-if="!isMobile()">
          <div class="demo-alignment" id="ustBolum">
            <v-select
              :value="selected"
              v-model="selected"
              @input="ps"
              :options="options"
              style="width: 220px"
            ></v-select>
            <v-select
              :options="['10', '11', '12', '50']"
              v-model="selectedDepo"
              @input="ps"
            ></v-select>
            <vs-input
              class="inputx"
              placeholder="Ürün Kodu"
              @keyup.enter="barkodOku()"
              id="barkodM"
              :ref="barkod"
              v-model="barkod"
              autocomplete="off"
            />
          </div>
          <div
            class="demo-alignment"
            style="font-weight: bold; color: green"
            v-if="!isMobile()"
          >
            <vs-button
              @click="activePromptSiparis = true"
              style="border-radius: 5px"
              color="dark"
              type="gradient"
              v-if="!isMobile()"
              >Sipariş Yaz</vs-button
            >
            <vs-button
              @click="yazdir()"
              color="danger"
              style="border-radius: 5px"
              type="gradient"
              v-if="!isMobile()"
              >Yazdır</vs-button
            >
            <vs-button
              @click="activePromptTemizle = true"
              color="#fc9551"
              gradient-color-secondary="rgb(255, 115, 0)"
              style="border-radius: 5px"
              type="gradient"
              v-if="!isMobile()"
              >Listeyi Temizle</vs-button
            >
            <vs-button
              @click="sayimSifirla()"
              color="success"
              style="border-radius: 5px"
              type="gradient"
              v-if="!isMobile()"
              >Sayım Sıfırla</vs-button
            >
            <vs-button
              @click="stokListeAc()"
              style="border-radius: 5px"
              type="gradient"
              v-if="!isMobile()"
              >Stok Listesi</vs-button
            >
            <vs-button
              @click="sipararisListesi()"
              color="#bc49c4"
              gradient-color-secondary="rgb(110, 4, 138)"
              style="border-radius: 5px"
              type="gradient"
              v-if="!isMobile()"
              >Sipariş Listesi</vs-button
            >
            <span v-if="sipariseGoreUrunListesi.length > 0">
              <download-excel
                v-if="!isMobile()"
                class="btn btn-default"
                :data="sipariseGoreUrunListesi"
                name="siparisListesi.xls"
              >
                Excel İndir
              </download-excel></span
            >
            <vs-button
              @click="topluKargoGonder()"
              color="#87b6b8"
              gradient-color-secondary="#5f9ea0"
              style="border-radius: 5px"
              type="gradient"
              v-if="!isMobile()"
              >Depo Kargo Gönder</vs-button
            >
          </div>
          <div
            class="demo-alignment"
            style="font-weight: bold; color: green"
            v-if="!isMobile()"
          >
            <label>Sayım Yap</label
            ><vs-switch style="border-radius: 20px" v-model="sayimDurumu" />
            <label>Kdv</label
            ><vs-switch style="border-radius: 20px" v-model="kdvDurumu" />
            <span style="color: green"
              >Toplam Parça : {{ adetTopla() }} Adet</span
            >
            <span style="color: red">
              Toplam Tutar : {{ toplamTutar() }} TL</span
            >
            <vs-input
              class="inputx"
              type="hidden"
              id="barkodM"
              @keyup.enter="barkodOku()"
              :ref="barkodAdet"
              v-model="barkodAdet"
            />
          </div>
        </vx-card>

        <vx-card title="" v-if="isMobile()">
          <div class="demo-alignment">
            <vs-input
              class="inputx"
              placeholder="Ürün Kodu"
              @keyup.enter="barkodOku()"
              id="barkodM"
              :ref="barkod"
              v-model="barkod"
              autocomplete="off"
            />
            <vs-button
              color="blue"
              :disabled="validated == 0"
              @click="bilgiler()"
              class="w-/4"
              >Bilgiler</vs-button
            >
            <vs-button
              color="red"
              :disabled="validated == 0"
              @click="stokListeAc()"
              class="w-2/4"
              >Stok Ara</vs-button
            >
          </div>
        </vx-card>

        <vx-card title="" style="margin-top: 10px">
          <vs-table
            search
            pagination
            :data="sortArrays1(sipariseGoreUrunListesi)"
          >
            <template slot="thead">
              <vs-th sort-key="stokkodu">Stok</vs-th>

              <vs-th>Fiyat</vs-th>

              <vs-th>Depo</vs-th>
              <vs-th>Adet</vs-th>
              <vs-th>Kontrol</vs-th>
              <vs-th>Toplam</vs-th>
              <vs-th>Çıkar</vs-th>
              <vs-th>Sil</vs-th>
              <vs-th sort-key="stokkodu">Barkod</vs-th>

              <vs-th>Stok Adı </vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :state="indextr == 0 ? 'success' : null"
                :key="indextr"
                v-for="(tr, indextr) in data"
              >
                <vs-td :data="data[indextr].STOK_KODU">
                  <span @click="renkListesi(data[indextr].ortakKod)"
                    >{{ data[indextr].STOK_KODU }}
                  </span>
                </vs-td>

                <vs-td :data="data[indextr].SATIS_FIAT1">
                  <span @click="paketListesi(data[indextr].STOK_KODU)">{{
                    data[indextr].SATIS_FIAT1
                  }}</span>
                </vs-td>
                <vs-td :data="data[indextr].depoAdet">
                  {{ data[indextr].depoAdet }}
                </vs-td>
                <vs-td :data="data[indextr].adet">
                  <span
                    v-if="
                      parseInt(data[indextr].adet) >
                      parseInt(data[indextr].kontrolAdet)
                    "
                    style="color: red; font-weight: bold"
                  >
                    <span
                      @click="
                        adetStokKod(data[indextr].STOK_KODU);
                        activePrompt = true;
                      "
                      >{{ data[indextr].adet }}</span
                    >
                  </span>
                  <span
                    v-if="data[indextr].adet == data[indextr].kontrolAdet"
                    style="color: green; font-weight: bold"
                  >
                    <span
                      @click="
                        adetStokKod(data[indextr].STOK_KODU);
                        activePrompt = true;
                      "
                      >{{ data[indextr].adet }}</span
                    >
                  </span>
                </vs-td>
                <vs-td :data="data[indextr].kontrolAdet">
                  <span
                    v-if="
                      parseInt(data[indextr].adet) >
                      parseInt(data[indextr].kontrolAdet)
                    "
                    style="color: red; font-weight: bold"
                  >
                    <span
                      @click="
                        adetStokKod(data[indextr].STOK_KODU);
                        activePrompt = true;
                      "
                      >{{ data[indextr].kontrolAdet }}</span
                    >
                  </span>
                  <span
                    v-if="data[indextr].adet == data[indextr].kontrolAdet"
                    style="color: green; font-weight: bold"
                  >
                    <span
                      @click="
                        adetStokKod(data[indextr].STOK_KODU);
                        activePrompt = true;
                      "
                      >{{ data[indextr].kontrolAdet }}</span
                    >
                  </span>
                </vs-td>

                <vs-td :data="data[indextr].toplam">
                  {{ data[indextr].SATIS_FIAT1 * data[indextr].adet }}
                </vs-td>
                <vs-td :data="data[indextr].stokAdi">
                  <feather-icon
                    icon="FolderMinusIcon"
                    class="cursor-pointer"
                    svgClasses="w-8 h-8"
                    @click="
                      listedenCikar1(data[indextr].id, data[indextr].barkod)
                    "
                  />
                </vs-td>
                <vs-td :data="data[indextr].stokAdi">
                  <feather-icon
                    icon="TrashIcon"
                    class="cursor-pointer"
                    svgClasses="w-8 h-8"
                    style="color: red"
                    @click="listedenCikar(data[indextr].id)"
                  />
                </vs-td>
                <vs-td :data="data[indextr].barkod">
                  {{ data[indextr].barkod }}
                </vs-td>

                <vs-td :data="data[indextr].STOK_ADI">
                  {{ data[indextr].STOK_ADI }}
                </vs-td>
              </vs-tr>

              <vs-tr>
                <vs-td> </vs-td>
                <vs-td> </vs-td>
                <vs-td> </vs-td>
                <vs-td> </vs-td>
                <vs-td style="font-weight: bold; color: black"> </vs-td>
                <vs-td> </vs-td>
                <vs-td> </vs-td>
                <vs-td> </vs-td>
              </vs-tr>
            </template>
          </vs-table>

          <div id="printMe" style="height: 1px; overflow: hidden; width: 100%">
            <template id="app">
              <table border="1px;" style="width: 100%">
                <tr>
                  <td>
                    {{ selected.label }}
                  </td>
                  <td align="right">
                    {{ getNow() }}
                  </td>
                </tr>
                <tr>
                  <td></td>
                </tr>
              </table>
            </template>
            <template>
              <table style="width: 100% !important">
                <tr>
                  <th
                    sort-key="stokkodu"
                    style="border: 1px solid black; padding: 3px"
                  >
                    Stok Kodu
                  </th>

                  <th style="border: 1px solid black; padding: 3px">
                    Stok Adı
                  </th>
                  <th style="border: 1px solid black; padding: 3px">Renk</th>
                  <th style="border: 1px solid black; padding: 3px">
                    Seri Sayısı
                  </th>
                  <th style="border: 1px solid black; padding: 3px">
                    Adet Sayısı
                  </th>
                  <th style="border: 1px solid black; padding: 3px">
                    Adet Fiyatı
                  </th>
                  <th style="border: 1px solid black; padding: 3px">
                    Seri Fiyatı
                  </th>
                  <th style="border: 1px solid black; padding: 3px">Toplam</th>
                </tr>

                <tr
                  :key="indextr"
                  v-for="(tr, indextr) in sortArrays(sipariseGoreUrunListesi)"
                >
                  <td style="border: 1px solid black; padding: 3px">
                    {{ tr.STOK_KODU }}
                  </td>

                  <td style="border: 1px solid black; padding: 3px">
                    {{ tr.STOK_ADI }}
                  </td>
                  <td style="border: 1px solid black; padding: 3px">
                    {{ tr.renk }}
                  </td>
                  <td style="border: 1px solid black; padding: 3px">
                    {{ tr.adet }}
                  </td>
                  <td style="border: 1px solid black; padding: 3px">
                    {{ tr.paketIcerikAdet * tr.adet }}
                  </td>
                  <td style="border: 1px solid black; padding: 3px">
                    {{ tr.SATIS_FIAT1 / tr.paketIcerikAdet }}
                  </td>
                  <td style="border: 1px solid black; padding: 3px">
                    {{ tr.SATIS_FIAT1 }}
                  </td>

                  <td style="border: 1px solid black; padding: 3px">
                    {{ tr.SATIS_FIAT1 * tr.adet }}
                  </td>
                </tr>

                <tr>
                  <td style="border: 1px solid black; padding: 3px"></td>
                  <td style="border: 1px solid black; padding: 3px"></td>
                  <td style="border: 1px solid black; padding: 3px"></td>
                  <td style="border: 1px solid black; padding: 3px"></td>
                  <td style="border: 1px solid black; padding: 3px"></td>
                  <td style="border: 1px solid black; padding: 3px"></td>
                  <td style="border: 1px solid black; padding: 3px">
                    Kdv Hariç
                  </td>
                  <td style="border: 1px solid black; padding: 3px">
                    {{ toplamTutar() }}
                  </td>
                </tr>
                <tr>
                  <td style="border: 1px solid black; padding: 3px"></td>
                  <td style="border: 1px solid black; padding: 3px"></td>
                  <td style="border: 1px solid black; padding: 3px"></td>
                  <td style="border: 1px solid black; padding: 3px"></td>
                  <td style="border: 1px solid black; padding: 3px"></td>
                  <td style="border: 1px solid black; padding: 3px"></td>
                  <td style="border: 1px solid black; padding: 3px">
                    Kdv Dahil
                  </td>
                  <td style="border: 1px solid black; padding: 3px">
                    {{ toplamTutarKdv() }}
                  </td>
                </tr>
                <tr>
                  <td style="border: 1px solid black; padding: 3px"></td>
                  <td style="border: 1px solid black; padding: 3px"></td>
                  <td style="border: 1px solid black; padding: 3px"></td>
                  <td style="border: 1px solid black; padding: 3px"></td>
                  <td style="border: 1px solid black; padding: 3px"></td>
                  <td style="border: 1px solid black; padding: 3px"></td>
                  <td style="border: 1px solid black; padding: 3px">
                    Toplam Adet
                  </td>
                  <td style="border: 1px solid black; padding: 3px">
                    {{ toplamAdet() }}
                  </td>
                </tr>
                <tr>
                  <td
                    colspan="8"
                    style="
                      border: 1px solid black;
                      padding: 3px;
                      text-align: right;
                    "
                  >
                    Fiyatlarımıza KDV Dahil Değildir
                  </td>
                </tr>
                <tr>
                  <td
                    colspan="8"
                    style="
                      border: 1px solid black;
                      padding: 3px;
                      text-align: right;
                    "
                  >
                    Siparişinizin geçerlilik süresi {{ gecerlilikTarihi }} mesai
                    bitimine kadardır.
                  </td>
                </tr>
              </table>
            </template>
          </div>
          <vs-prompt
            title="Adet İşlemleri"
            acceptText="Adet Gir"
            cancelText="Vazgeç"
            @accept="adetDegistir"
            :active.sync="activePrompt"
          >
            <div class="con-exemple-prompt">
              <span>Adet</span>
              <vs-input
                type="number"
                placeholder="Sayı Giriniz"
                vs-placeholder="Code"
                v-model="partiVal"
                class="mt-3 w-full"
              />
            </div>
          </vs-prompt>

          <vs-prompt
            title="Sipariş İşlemleri"
            cancelText="Çıkış"
            button-accept="false"
            :active.sync="activePromptSiparis"
          >
            <vs-input
              type="text"
              placeholder="Açıklama"
              vs-placeholder="Açıklama"
              v-model="siparisAciklama"
              class="mt-3 w-full"
            />
            <vs-input
              type="text"
              placeholder="Açıklama"
              vs-placeholder="Açıklama 1"
              v-model="siparisAciklama1"
              class="mt-3 w-full"
            />
            <vs-input
              type="text"
              placeholder="Açıklama"
              vs-placeholder="Açıklama 2"
              v-model="siparisAciklama2"
              class="mt-3 w-full"
            />

            <vs-button color="blue" @click="siparisYaz1()" class="w-2/4"
              >Kdv Dahil</vs-button
            >
            <vs-button color="red" @click="siparisYaz(0)" class="w-2/4"
              >Kdv Hariç</vs-button
            >
          </vs-prompt>

          <vs-prompt
            title="Sipariş Temizle"
            acceptText="Sipariş Temizle"
            cancelText="Vazgeç"
            @accept="listeyiTemizle"
            :active.sync="activePromptTemizle"
          >
          </vs-prompt>
        </vx-card>
      </div>
    </div>

    <vs-popup
      fullscreen
      class="holamundo"
      title="Renk Seçenekleri"
      :active.sync="popupRenk"
    >
      <vs-table :data="ciktiRenkListesi">
        <template slot="thead">
          <vs-th sort-key="STOK_KODU">Stok Kodu</vs-th>
          <vs-th sort-key="renk">Renk</vs-th>
          <vs-th sort-key="depoAdet">Depo Adet</vs-th>
          <vs-th sort-key="stokkodu">Ekle</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].STOK_KODU">
              {{ data[indextr].STOK_KODU }}
            </vs-td>
            <vs-td :data="data[indextr].renk">
              {{ data[indextr].renk }}
            </vs-td>
            <vs-td :data="data[indextr].depoAdet">
              {{ data[indextr].depoAdet }}
            </vs-td>

            <vs-td>
              <vs-button
                @click="satirEkle(data[indextr].barkod)"
                color="red"
                type="filled"
                >Ekle</vs-button
              >
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>

    <vs-popup
      fullscreen
      class="holamundo"
      title="Renk Seçenekleri"
      :active.sync="popupPaket"
    >
      <vs-table :data="ciktiPaketListesi">
        <template slot="thead">
          <vs-th sort-key="STOK_KODU">Stok Kodu</vs-th>
          <vs-th sort-key="STOK_ADI">Stok Adı</vs-th>
          <vs-th sort-key="adet">Adet</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].STOK_KODU">
              {{ data[indextr].STOK_KODU }}
            </vs-td>
            <vs-td :data="data[indextr].STOK_ADI">
              {{ data[indextr].STOK_ADI }}
            </vs-td>
            <vs-td :data="data[indextr].depoAdet">
              {{ data[indextr].adet }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>

    <vs-popup
      fullscreen
      class="holamundo"
      title="Satış Bilgileri"
      :active.sync="popupBilgiler"
    >
      <table>
        <tr>
          <td>Cari</td>
          <td>
            <v-select
              :value="selected"
              v-model="selected"
              @input="ps"
              :options="options"
            ></v-select>
          </td>
        </tr>
        <tr>
          <td>Depo</td>
          <td>
            <v-select
              :options="['10', '11', '12', '50']"
              v-model="selectedDepo"
              @input="ps"
            ></v-select>
          </td>
        </tr>

        <tr>
          <td>Kontrol</td>
          <td>
            <vs-input
              class="inputx"
              placeholder="Kontrol"
              id="kontrol"
              @keyup.enter="kontrol()"
              :ref="barkodAdetKontrol"
              v-model="barkodAdetKontrol"
            />
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <span style="color: green"
              >Toplam Parça : {{ adetTopla() }} Adet</span
            >
            <span style="color: red">
              Toplam Tutar : {{ toplamTutar() }} TL</span
            >
          </td>
        </tr>
        <tr>
          <td>
            <vs-button
              @click="activePromptTemizle = true"
              color="warning"
              type="filled"
              v-if="isMobile()"
              >Listeyi Temizle</vs-button
            >
          </td>
          <td><label>Sayım Yap</label><vs-switch v-model="sayimDurumu" /></td>
        </tr>
      </table>
    </vs-popup>

    <vs-popup
      fullscreen
      class="holamundo"
      title="Stok Listesi"
      :active.sync="popupStokListesi"
    >
      <vs-input
        class="inputx"
        placeholder="Barkod"
        @keyup.enter="stokListesi()"
        :ref="barkodListe"
        v-model="barkodListe"
      />
      <vs-table :data="dataStokListesi">
        <template slot="thead">
          <vs-th sort-key="stokKodu">Stok Kodu</vs-th>
          <vs-th sort-key="stokAdet">Stok Adet</vs-th>
          <vs-th sort-key="renk">Renk</vs-th>
          <vs-th sort-key="beden">Beden</vs-th>

          <vs-th></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].orderNumber">
              {{ data[indextr].stokKodu }}
            </vs-td>

            <vs-td :data="data[indextr].quantity">
              {{ data[indextr].stokAdet }}
            </vs-td>
            <vs-td :data="data[indextr].musteriAdi">
              {{ data[indextr].renk }}
            </vs-td>
            <vs-td :data="data[indextr].merchantSku">
              {{ data[indextr].beden }}
            </vs-td>

            <vs-td>
              <vs-button
                @click="satirEkle(data[indextr].Barkod)"
                color="success"
                type="filled"
                >Ekle</vs-button
              >
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>

    <vs-popup
      fullscreen
      class="holamundo"
      title="Sipariş Listesi"
      :active.sync="popupSiparisListesi"
    >
      <vs-table :data="dataSiparisListesi">
        <template slot="thead">
          <vs-th sort-key="stokkodu">Cari</vs-th>
          <vs-th>Depo</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].cariAdi">
              {{ data[indextr].cariAdi }}
            </vs-td>

            <vs-td :data="data[indextr].depoKodu">
              {{ data[indextr].depoKodu }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>
  </div>
</template>

   


<script>
import vSelect from "vue-select";
import state from "../../store/state";
import Store from "../../store/store";
import { isMobile } from "mobile-device-detect";

import { StreamBarcodeReader } from "vue-barcode-reader";

export default {
  components: {
    "v-select": vSelect,
    StreamBarcodeReader,
  },
  data() {
    return {
      //  listeKontrol: false,
      siparisAciklama: "",
      siparisAciklama1: "",
      siparisAciklama2: "",
      active: false,
      adetKod: "",
      text: "0",
      id: null,
      sayimDurumu: false,
      kdvDurumu: false,
      popupBilgiler: false,
      popupStokListesi: false,
      popupSiparisListesi: false,
      popupPaket: false,
      options: [],
      optionsParti: [],
      pazaryeriTum: [],
      list: [],
      dataStokListesi: [],
      dataSiparisListesi: [],
      ciktiRenkListesi: [],
      ciktiPaketListesi: [],
      listSonFaturalar: [],
      listSiparis: [],
      sipariseGoreUrunListesi: [],
      progress: 0,
      activePrompt: false,
      activePromptSiparis: false,
      activePromptTemizle: false,
      popupRenk: false,
      pazaryeriVal: "",
      partiVal: "",
      toplamParca: 0,
      selected: { id: 0, label: "Cari" },
      selectedDepo: "",
      iadeModel: { id: 0, label: "İade red" },
      selectedParti: { id: 0, label: "Parti Nolar" },
      popupActive: false,
      popupFatura: false,
      popupActiveSiparis: false,
      popupActiveCikti: false,
      barkod: "",
      barkodAdet: "",
      cariKod: "",
      siparisBulOrderNumber: "",
      genelSiparisNo: "",

      genelKargoAdi: "",
      genelKargoNo: "",
      genelMusteri: "",
      hediyeMi: 0,
      genelToplam: 0,
      eklenenDeger: "",
      indext: 0,
      indext1: 0,
      urunResim: "",
      validated: 1,
      validatedF: 1,
      siparisToplamParca: 0,
      eklenenToplamParca: 0,
      askiDurumu: false,
      aski: 0,
      imageLink: "",
      ciktiListesi: [],
      jsonD: "",
      dr: "",
      popupActiveFaturaCikti: false,
      receiptId: 0,
      faturaNo: "",
      ilkOkuma: 0,
      recId: 0,
      total: 0,
      faturaAranan: "",
      faturaBulOrderNumber: "",
      im: 0,
      iadeOrderNumber: "",
      iadeLineItemId: "",
      barkodAdetKontrol: "",
      ustBolumDeger: 0,
      barkodListe: "",
      kontrolAdetSistem: 0,
      secilenKod: "",
      aramaKontrol: "",
      tarihs: "",
      gecerlilikTarihi: "",
    };
  },
  methods: {
    hataMuzik() {
      let url = state.sistemAddress;
      url = url.replace("sistem.asmx?WSDL", "ses/");
      var audio = new Audio(url + "hata.wav");
      audio.play();
    },
    onayMuzik() {
      let url = state.sistemAddress;
      url = url.replace("sistem.asmx?WSDL", "ses/");
      var audio = new Audio(url + "ok.wav");
      audio.play();
    },
    adetStokKod(kod) {
      //alert(kod)
      this.secilenKod = kod;
    },
    sortArrays(arrays) {
      return _.orderBy(arrays, "id", "asc");
    },
    sortArrays1(arrays) {
      return _.orderBy(arrays, "guncellemeTarihi", "desc");
    },
    stokListeAc() {
      this.stokListesi();
      this.popupStokListesi = true;
    },
    topluKargoGonder() {
      const vs = this.$vs;
      if (this.selected.id == 0) {
        vs.notify({
          title: "Cari",
          text: "Cari seçiniz",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      } else {
        const args = {
          cariKodu: this.selected.id,
          paketAdedi: "1",
        };
        console.log(args);
        soap.createClient(url, function (err, client) {
          client.toptanHepsiJetUrunGonder(args, function (err, result) {
            vm.veriler = JSON.parse(result.toptanHepsiJetUrunGonderResult);
            console.log(vm.veriler);
            if (vm.veriler.response == "Ok") {
              vs.notify({
                title: "Gönderildi",
                text: "Depo kargo gönderimi başarılı.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
            } else {
              vs.notify({
                title: "Hata",
                text: "Depo kargo gönderimi hatalı.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "red",
                position: "top-center",
              });
            }
          });
        });
      }
    },
    sipararisListesi() {
      this.dataSiparisListesi = [];
      //this.dataStokListesi=null
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {};
      soap.createClient(url, function (err, client) {
        client.acikHizliSiparisListe(args, function (err, result) {
          vm.veriler = JSON.parse(result.acikHizliSiparisListeResult);
          vm.dataSiparisListesi = vm.veriler;
          vm.popupSiparisListesi = true;
        });
      });
    },
    stokListesi() {
      this.dataStokListesi = [];
      //this.dataStokListesi=null
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        token: Store.state.tokenId,
        kod: vm.barkodListe,
        pazaryeri: "",
        depoNo: this.selectedDepo,
      };
      soap.createClient(url, function (err, client) {
        client.stokListesiToptan(args, function (err, result) {
          if (result.stokListesiToptanResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          vm.veriler = JSON.parse(result.stokListesiToptanResult);
          vm.dataStokListesi = vm.veriler;
        });
      });
    },
    bilgiler() {
      this.popupBilgiler = true;
    },
    barkodAc() {
      this.text = "";
    },
    ustBolumDegistir() {
      if (this.ustBolumDeger == 1) {
        document.getElementById("ustBolum").style.height = "100px";
        this.ustBolumDeger = 0;
      } else {
        document.getElementById("ustBolum").style.height = "0px";
        this.ustBolumDeger = 1;
      }
    },
    onDecode(a, b, c) {
      // console.log(a, b, c);
      if (this.text == "") {
        this.barkod = a;
        this.barkodOku();
      }
      /* if (this.id) clearTimeout(this.id);
      this.id = setTimeout(() => {
        if (this.text === a) {
          this.text = "";
        }
      }, 5000);*/
    },
    onLoaded() {
      // console.log("load");
    },
    satirEkle(barkod) {
      //alert(barkod)
      // this.listeKontrol = true;
      this.barkod = barkod;
      this.barkodOku();
      this.popupRenk = false;
    },
    renkListesi(ortakKod) {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      //console.log(this.pazaryeriVal.trim()+"**"+this.partiVal+"**"+vm.barkod+"**"+this.aski+"**"+gelenorder+"**"+Store.state.tokenId)

      const args = { ortakKod: ortakKod, depoKodu: this.selectedDepo };
      soap.createClient(url, function (err, client) {
        client.hizliSiparisRenkListesi(args, function (err, result) {
          vm.veriler = JSON.parse(result.hizliSiparisRenkListesiResult);

          vm.ciktiRenkListesi = vm.veriler;
        });
      });

      vm.popupRenk = true;
    },
    paketListesi(stokKodu) {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      //console.log(this.pazaryeriVal.trim()+"**"+this.partiVal+"**"+vm.barkod+"**"+this.aski+"**"+gelenorder+"**"+Store.state.tokenId)

      const args = { stokKodu: stokKodu };
      soap.createClient(url, function (err, client) {
        client.paketIcerigi(args, function (err, result) {
          vm.veriler = JSON.parse(result.paketIcerigiResult);

          vm.ciktiPaketListesi = vm.veriler;
        });
      });

      vm.popupPaket = true;
    },
    getNow: function () {
      const today = new Date();
      const date =
        today.getDate() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getFullYear();
      const time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      const dateTime = date + " " + time;
      return dateTime;
    },
    adetTopla() {
      let toplam = 0;
      if (
        (this.sipariseGoreUrunListesi != null) &
        (this.sipariseGoreUrunListesi != "")
      ) {
        this.sipariseGoreUrunListesi.forEach((element) => {
          toplam = toplam + parseInt(element.adet);
        });
      }
      return toplam;
    },
    toplamTutar() {
      let toplam = 0;
      if (
        (this.sipariseGoreUrunListesi != null) &
        (this.sipariseGoreUrunListesi != "")
      ) {
        this.sipariseGoreUrunListesi.forEach((element) => {
          toplam = toplam + parseFloat(element.adet * element.SATIS_FIAT1);
        });
      }
      return toplam;
    },
    toplamAdet() {
      let toplam = 0;
      if (
        (this.sipariseGoreUrunListesi != null) &
        (this.sipariseGoreUrunListesi != "")
      ) {
        this.sipariseGoreUrunListesi.forEach((element) => {
          toplam = toplam + parseFloat(element.adet);
        });
      }
      return toplam;
    },
    toplamTutarKdv() {
      let toplam = 0;
      if (
        (this.sipariseGoreUrunListesi != null) &
        (this.sipariseGoreUrunListesi != "")
      ) {
        this.sipariseGoreUrunListesi.forEach((element) => {
          toplam = toplam + parseFloat(element.adet * element.SATIS_FIAT1);
        });
      }
      return Math.round(toplam * 1.10 * 100) / 100;
    },
    kontrol() {
      const vm = this;
      const vs = this.$vs;
      vm.barkod = vm.barkod.toUpperCase();
      //console.log(vm.sipariseGoreUrunListesi)
      vm.indext = vm.indexbul(
        vm.sipariseGoreUrunListesi,
        (item) => item.barkod === vm.barkod
      );

      if (vm.sayimDurumu === true) {
        //alert(vm.indext)

        // alert(vm.indext)
        // alert(vm.sipariseGoreUrunListesi[vm.indext].eklenen)
        // alert(vm.indext)
        if (vm.indext == -1) {
          //  var audio = new Audio('file://D://TKM1010019a.mp3'); // path to file
          //    audio.play();
          vm.hataMuzik();
          vs.notify({
            title: "Paketleme",
            text: "Okutulan Ürün Sipariş Listesinde Yok",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center",
          });
        } else {
          if (
            vm.sipariseGoreUrunListesi[vm.indext].kontrolAdet >=
            vm.sipariseGoreUrunListesi[vm.indext].adet
          ) {
            vm.hataMuzik();
            vs.notify({
              title: "Paketleme",
              text: "Lütfen Fazla Ürün Okutmayınız",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "red",
              position: "top-center",
            });
          } else {
            // var currentdate = new Date();
            // var dt=currentdate.getFullYear()+"-"+currentdate.getUTCMonth()+"-"+currentdate.getUTCDay()+" "+currentdate.getUTCHours()+":"+currentdate.getMinutes()+":"+currentdate.getSeconds()+"."+currentdate.getMilliseconds();
            // console.log(dt);
            // vm.sipariseGoreUrunListesi[vm.indext].guncellemeTarihi=dt;
            vm.onayMuzik();

            vm.sipariseGoreUrunListesi[vm.indext].kontrolAdet =
              vm.sipariseGoreUrunListesi[vm.indext].kontrolAdet + 1;
            if (
              vm.sipariseGoreUrunListesi[vm.indext].kontrolAdet <
              vm.sipariseGoreUrunListesi[vm.indext].kontrolAdet + 1
            ) {
              // alert(vm.sipariseGoreUrunListesi[vm.indext].kontrolAdet)
              vm.kontrolAdetGuncelle(
                vm.barkodAdetKontrol,
                vm.sipariseGoreUrunListesi[vm.indext].kontrolAdet,
                vm.indext
              );
              //console.log(vm.tarihs)
            }
          }
        }
      } else {
        vm.ps();
      }
      vm.barkod = "";
      document.getElementById("barkodM").focus();
    },
    kontrolAdetGuncelle(barkod, adet, index) {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        cariKodu: this.selected.id,
        depoKodu: this.selectedDepo,
        barkod: barkod,
        adet: adet,
      };
      // console.log(args)
      soap.createClient(url, function (err, client) {
        client.kontrolAdetGuncelle(args, function (err, result) {
          //console.log(result.kontrolAdetGuncelleResult)
          vm.veriler = JSON.parse(result.kontrolAdetGuncelleResult);

          vm.sipariseGoreUrunListesi[index].guncellemeTarihi =
            vm.veriler[0].guncellemeTarihi;
        });
      });
    },
    sayimSifirla(barkod, adet) {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = { cariKodu: this.selected.id, depoKodu: this.selectedDepo };
      // console.log(args)
      soap.createClient(url, function (err, client) {
        client.sayimSifirla(args, function () {
          vm.ps();
        });
      });
    },
    yazdir() {
      this.ps();
      setTimeout(this.yazdirBekle, 5000);
    },
    yazdirBekle() {
      this.$htmlToPaper("printMe");
    },
    siparisYaz1() {
      this.kdvDurumu = true;
      this.siparisYaz(1);
    },
    siparisYaz(drm) {
      if (drm == 0) {
        this.kdvDurumu = false;
      }
      // alert(anaStokKodu)
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      //alert(this.kdvDurumu)
      const args = {
        islemTipi: "siparis",
        cariKod: this.selected.id,
        depoNo: this.selectedDepo,
        kdvDurumu: this.kdvDurumu,
        siparisAciklama: this.siparisAciklama,
        siparisAciklama1: this.siparisAciklama1,
        siparisAciklama2: this.siparisAciklama2,
      };
      // console.log(this.selected.id)
      soap.createClient(url, function (err, client) {
        client.depoHizlisatisIslemi(args, function (err, result) {
          vm.veriler = JSON.parse(result.depoHizlisatisIslemiResult);
          //console.log(vm.veriler)
          if (vm.veriler.response == "Ok") {
            vs.loading.close("#button-with-loading-partile > .con-vs-loading");
            vs.notify({
              title: "Sipariş Yazıldı",
              text: "Sipariş Yazıldı",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
            vm.listeTemizle();
          } else {
            vs.notify({
              title: "Sipariş Yazılamadı",
              text: "Sipariş Yazmada Hata Oluştu",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "error",
              position: "top-center",
            });
          }
        });
      });
    },
    irsaliyeYaz() {
      // alert(anaStokKodu)
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        islemTipi: "irsaliye",
        cariKodu: this.selected.id,
        depoKodu: this.selectedDepo,
      };
      // console.log(args)
      soap.createClient(url, function (err, client) {
        client.depoHizlisatisIslemi(args, function (err, result) {
          vm.veriler = JSON.parse(result.depoHizlisatisIslemiResult);
          if (vm.veriler.response == "Ok") {
            vs.loading.close("#button-with-loading-partile > .con-vs-loading");
            vs.notify({
              title: "İrsaliye Yazıldı",
              text: "İrsaliye Yazıldı",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
          } else {
            vs.notify({
              title: "İrsaliye Yazılamadı",
              text: "İrsaliye Yazmada Hata Oluştu",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "error",
              position: "top-center",
            });
          }
        });
      });
    },
    listedenCikar(id) {
      // alert(anaStokKodu)
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        id: id,
        cariKodu: this.selected.id,
        depoKodu: this.selectedDepo,
      };
      // console.log(args)
      soap.createClient(url, function (err, client) {
        client.hizliSatisSil(args, function () {
          vm.ps();
        });
      });
    },
    listeyiTemizle() {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = { cariKodu: this.selected.id, depoKodu: this.selectedDepo };
      // console.log(args)
      soap.createClient(url, function (err, client) {
        client.hizliSatisTemizle(args, function () {
          vm.ps();
        });
      });
    },
    listedenCikar1(id, barkod) {
      // alert(anaStokKodu)
      this.barkodAdet = -1;
      this.barkod = barkod;
      this.barkodOku();
    },
    adetDegistir() {
      // alert(anaStokKodu)
      // alert(this.secilenKod)
      this.barkodAdet = this.partiVal;
      this.barkod = this.secilenKod;
      this.barkodOku("adetDegistir");
    },

    print() {
      // Pass the element id here
      this.$htmlToPaper("printMe");
    },
    indexbul(array, conditionFn) {
      const item = array.find(conditionFn);

      return array.indexOf(item);
    },
    ps1(text) {
      this.partiVal = text;
    },
    ps() {
      var vm = this;
      vm.sipariseGoreUrunListesi = null;
      vm.sipariseGoreUrunListesi = "";
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        cariKodu: this.selected.id,
        depoKodu: this.selectedDepo,
        islemTipi: 0,
        aranan: this.barkod,
      };
      soap.createClient(url, function (err, client) {
        client.acikHizliSiparis(args, function (err, result) {
          console.log(args);
          vm.veriler = JSON.parse(result.acikHizliSiparisResult);
          console.log("result.acikHizliSiparisResult:" + vm.veriler);
          vm.gecerlilikTarihi = vm.veriler[0].gecerlilikTarihi;
          vm.sipariseGoreUrunListesi = vm.veriler;
          console.log("vm.gecerlilikTarihi:" + vm.gecerlilikTarihi);
        });
      });
    },
    ekleButtonPs() {
      this.barkod = "";
      var vm = this;
      vm.sipariseGoreUrunListesi = null;
      vm.sipariseGoreUrunListesi = "";
      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        cariKodu: this.selected.id,
        depoKodu: this.selectedDepo,
        islemTipi: 0,
        aranan: this.barkod,
      };
      soap.createClient(url, function (err, client) {
        client.acikHizliSiparis(args, function (err, result) {
          console.log(args);
          vm.veriler = JSON.parse(result.acikHizliSiparisResult);
          //  console.log(vm.veriler);
          // vm.gecerlilikTarihi = vm.veriler[0].gecerlilikTarihi;
          vm.sipariseGoreUrunListesi = vm.veriler;
          console.log(vm.sipariseGoreUrunListesi);
          // console.log("vm.gecerlilikTarihi:" + vm.gecerlilikTarihi);
        });
      });
    },

    secilenPartiUrunleri() {
      const vs = this.$vs;

      if (this.pazaryeriVal == "" || this.partiVal == "") {
        vs.notify({
          title: "Paketleme",
          text: "Pazaryerini ve Parti Seçiniz",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      } else {
        var vm = this;

        const soap = require("soap");
        const url = state.sistemAddress;

        const args = {
          pazaryeri: this.pazaryeriVal,
          partiNo: this.partiVal,
          token: Store.state.tokenId,
        };
        soap.createClient(url, function (err, client) {
          client.partiUrunleri(args, function (err, result) {
            if (result.partiUrunleriResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            } else {
              vm.veriler = JSON.parse(result.partiUrunleriResult);
              vm.total = vm.veriler[0]["tt"];
              vm.list = vm.veriler;

              vm.popupActive = true;
            }
          });
        });
      }
    },
    faturaBul() {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        program: this.pazaryeriVal,
        EMPLOYEEID: Store.state.plasiyer,
        faturaAranan: vm.faturaBulOrderNumber,
      };
      soap.createClient(url, function (err, client) {
        client.sonFaturalar(args, function (err, result) {
          if (result.sonFaturalarResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          } else {
            //console.log(result.sonFaturalarResult)
            vm.veriler = JSON.parse(result.sonFaturalarResult);
            //.log(vm.veriler)
            vm.listSonFaturalar = vm.veriler;

            vm.popupFatura = true;
          }
        });
      });
    },
    siparisBul() {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      // alert(this.pazaryeriVal)
      const args = {
        pazaryeri: "Trendyol",
        token: Store.state.tokenId,
        sayfa: 0,
        orderNumber: this.siparisBulOrderNumber,
      };
      soap.createClient(url, function (err, client) {
        client.iadeListele(args, function (err, result) {
          if (result.iadeListeleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          } else {
            vm.veriler = JSON.parse(result.iadeListeleResult);
            vm.listSiparis = vm.veriler;
            vm.popupActiveSiparis = true;
          }
        });
      });
    },
    siparisSec() {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      // alert(this.pazaryeriVal)
      const args = {
        pazaryeri: "Trendyol",
        token: Store.state.tokenId,
        sayfa: 0,
        orderNumber: "",
      };
      soap.createClient(url, function (err, client) {
        client.iadeListele(args, function (err, result) {
          if (result.iadeListeleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          } else {
            vm.veriler = JSON.parse(result.iadeListeleResult);
            vm.listSiparis = vm.veriler;
            vm.popupActiveSiparis = true;
          }
        });
      });
    },
    barkodOku(islemNe) {
      // alert(gelenorder)
      if (this.sayimDurumu === true) {
        this.barkodAdetKontrol = this.barkod;
        //this.barkod='';
        this.kontrol();
      } else {
        const vm = this;
        const vs = this.$vs;
        vm.text = vm.barkod;

        if (vm.selected.id == "0") {
          vm.hataMuzik();
          vs.notify({
            title: "Cari Seçiniz",
            text: "Lütfen Cari Seçiniz",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success",
            position: "top-center",
          });
          vm.barkod = "";
          vm.barkodAdet = "";
          document.getElementById("barkodM").focus();
        } else {
          if (vm.barkodAdet == "") {
            vm.barkodAdet = 1;
          }
          const soap = require("soap");
          const url = state.sistemAddress;

          const args = {
            stokKodu: vm.barkod.toUpperCase(),
            adet: this.barkodAdet,
            cariKodu: this.selected.id,
            depoKodu: this.selectedDepo,
            islemTipi: 0,
            islemNe: islemNe,
          };
          soap.createClient(url, function (err, client) {
            client.muhasebeUrunBul(args, function (err, result) {
              vm.veriler = JSON.parse(result.muhasebeUrunBulResult);
              console.log(vm.veriler);
              if (vm.veriler.length > 0) {
                vm.onayMuzik();
                //  vm.gecerlilikTarihi=vm.veriler[0].gecerlilikTarihi
                if (vm.veriler[0].yenileme == "0") {
                  //alert(vm.sipariseGoreUrunListesi.length)
                  if (vm.sipariseGoreUrunListesi.length == 0) {
                    vm.sipariseGoreUrunListesi = vm.veriler;
                  } else {
                    vm.sipariseGoreUrunListesi.push(vm.veriler[0]);
                  }
                } else {
                  vm.indext = vm.indexbul(
                    vm.sipariseGoreUrunListesi,
                    (item) =>
                      item.barkod.replace(" ", "") === vm.veriler[0].barkod
                  );

                  vm.sipariseGoreUrunListesi[vm.indext].adet =
                    vm.veriler[0].adet;
                  vm.sipariseGoreUrunListesi[vm.indext].guncellemeTarihi =
                    vm.veriler[0].guncellemeTarihi;
                  // console.log(vm.veriler[0])
                  // vm.sipariseGoreUrunListesi.push(vm.veriler[0])
                  // console.log(vm.sipariseGoreUrunListesi)
                }
              } else {
                vm.hataMuzik();
              }
              vm.barkod = "";
              vm.barkodAdet = "";
              //document.getElementById("barkodM").focus();
              vm.ekleButtonPs();
            });
          });
        }
      }
    },

    stokGuncelle() {
      const vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = { program: "Trendyol", token: Store.state.tokenId };
      soap.createClient(url, function (err, client) {
        client.stokAdetFiyatGuncelle(args, function (err, result) {
          if (result.stokAdetFiyatGuncelleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.stokAdetFiyatGuncelleResult);
        });
      });
    },
    tekrarIslemeAl(orderNumber, merchantSku, partiNo) {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      // alert(this.pazaryeriVal)
      const args = {
        pazaryeri: this.pazaryeriVal.trim(),
        token: Store.state.tokenId,
        orderNumber: orderNumber,
      };
      soap.createClient(url, function (err, client) {
        client.tekrarIslemeAl(args, function (err, result) {
          if (result.siparisListeleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          } else {
            vm.siparisHazirla(orderNumber, merchantSku, partiNo);
          }
        });
      });
    },

    listeTemizle() {
      this.sipariseGoreUrunListesi = [];
      this.validated = 1;
      this.eklenenToplamParca = 0;
    },
    isMobile: function () {
      /*	var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;*/
      return isMobile;
    },
  },
  beforeMount() {
    //  console.log(Store.state.UserId)
    //setInterval(this.stokGuncelle,900000);

    var vm = this;
    //document.getElementById("barkodM").focus()
    const soap = require("soap");
    const url = state.sistemAddress;
    const args = {};
    soap.createClient(url, function (err, client) {
      client.cariBul(args, function (err, result) {
        vm.veriler = JSON.parse(result.cariBulResult);
        //vm.pazaryeriTum=vm.veriler
        //   console.log(vm.veriler);
        vm.options = vm.veriler;
      });
    });
  },
};
</script>

<style lang="scss" scoped>
.satirRengi {
  background-color: green;
  color: white;
}
.v-select .vs__selected {
  font-size: 10px;
}
.mb-base {
  margin-bottom: 0.75rem !important;
}
.list-view-item {
  .item-name,
  .item-description {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .item-name {
    -webkit-line-clamp: 2;
  }

  .item-description {
    -webkit-line-clamp: 5;
  }

  .grid-view-img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    transition: 0.35s;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);

    .grid-view-img {
      opacity: 0.9;
    }
  }
}
</style>
<style lang="stylus">
#parentx {
  overflow: hidden;
  height: 500px;
  position: relative;
}

.header-sidebar {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;

  h4 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    > button {
      margin-left: 10px;
    }
  }
}

.footer-sidebar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  > button {
    border: 0px solid rgba(0, 0, 0, 0) !important;
    border-left: 1px solid rgba(0, 0, 0, 0.07) !important;
    border-radius: 0px !important;
  }
}
</style>